<template>
	<div class="about-container">
		<div class="hero-section">
			<h1>The Structured Registry of All Things</h1>
			<p class="tagline">Organized from the Get-Go.</p>
		</div>

		<div class="content-section">
			<h2>The Random Web vs. The Structured Registry</h2>
			<p>
				The modern internet is a chaotic explosion of data.  Millions of sites compete for your attention and money using "black box" algorithms.
				Information is fragmented, duplicated, stale, and often lost.  Search engines try to organize this chaos after the fact, but they are fighting a losing battle.
			</p>
			<p>
				<strong>AppWAFN</strong> is different.  We believe information should be organized <strong>from the start.</strong>
			</p>
		</div>

		<div class="content-section">
			<h2>Structure by Design</h2>
			<p>Instead of a random web of pages, we provide a structured universe of <strong>Objects</strong>.</p>
			<ul>
				<li><strong>Collections (The Blueprint):</strong> Every type of information — a Person, an Event, a Coleman Lantern, a Classic Car — is a "Collection" with defined properties.</li>
				<li><strong>Instances (The Reality):</strong> A specific lantern or a specific person is an "Instance." It is defined once, and only once.</li>
				<li><strong>Trees (The Connection):</strong> Data isn't isolated; it grows into "Trees." A Lantern Instance links to a Service Event, which links to a Person Instance.</li>
			</ul>
		</div>

		<div class="content-section">
			<h2>The Physical Connection (QR & Provenance)</h2>
			<p>We bridge the gap between the physical and digital worlds.</p>
			<ul>
				<li><strong>QR Integration:</strong> Every physical object can be labeled with a unique QR code. Scan a lantern in your workshop, and you are taken directly to its digital Instance.</li>
				<li><strong>Provenance:</strong> Track the entire lifecycle of an object. From the factory to the first owner, through every repair, to its eventual sale in our Marketplace. The history of the "Thing" is maintained forever.</li>
			</ul>
		</div>

		<div class="content-section">
			<h2>The Human Record & Legacy</h2>
			<p>At the heart of the system is the <strong>Person</strong>.</p>
			<ul>
				<li><strong>Sovereignty:</strong> You own your data. No algorithms. No advertising. You are the customer, <strong>not</strong> the product.</li>
				<li><strong>Permanence:</strong> This is the "History of Mankind." Users choose whether their information and the history of their "Things" are perpetuated for future generations or deleted when their subscription ends.</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AboutView'
	}
</script>

<style scoped>
	.about-container {
		max-width: 800px;
		margin: 0 auto;
		padding: 40px 20px;
		font-family: Arial, sans-serif;
		line-height: 1.6;
		color: #333;
	}

	.hero-section {
		text-align: center;
		margin-bottom: 60px;
	}

	.hero-section h1 {
		font-size: 2.5em;
		color: #2c3e50;
		margin-bottom: 10px;
	}

	.tagline {
		font-size: 1.2em;
		color: #666;
		font-style: italic;
	}

	.content-section {
		margin-bottom: 40px;
	}

	.content-section h2 {
		color: #2c3e50;
		border-bottom: 2px solid #a6f4e5;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}

	ul {
		padding-left: 20px;
	}

	li {
		margin-bottom: 15px;
	}

	strong {
		color: #2c3e50;
	}
</style>
